import { RequestState } from '../../types'

export type Filter = {
  id: string
  name: string
  count: number
  profile: string
  requestState: RequestState
}

export type Account = {
  id: string
  name: string
  active: boolean
  lastActive: Date | undefined
  records: number
  isDemo: boolean
  subscription: SubscriptionInfo
  requestState: RequestState
  filters: Filter[]
}

export type SubscriptionInfo = {
  id: string
  name: string
  active: boolean
}

export type AccountsState = {
  requestState: RequestState
  error?: string
  accounts: Account[]
  loadedPages: number
  totalPages: number
  totalCount: number
}

export const initialAccountsState: AccountsState = {
  requestState: RequestState.NotLoaded,
  accounts: [],
  loadedPages: 0,
  totalPages: 0,
  totalCount: 0
}
